import { supabase } from "../lib/supabase";
import { RaidRoom } from "../utils/raidAuthoring";

export const raidAuthoringApi = {
  async rooms(): Promise<RaidRoom[]> {
    const { data, error } = await supabase
      .from("raid_room_assignment")
      .select("*")
      .order("room_order");
    if (error) throw error;
    return data || [];
  },
  async saveRoom(room: RaidRoom, roomName: string, description: string) {
    const { error } = await supabase.rpc("save_raid_room", {
      p_room: { ...room, room_name: roomName, description },
    });
    if (error) throw error;
    window.dispatchEvent(new Event("raidDataUpdated"));
  },
  async removeRoom(raidCode: string, roomCode: string) {
    const {error} = await supabase.rpc('detach_raid_room',{p_raid_code:raidCode,p_room_code:roomCode});
    if (error) throw error;
    window.dispatchEvent(new Event("raidDataUpdated"));
  },
  async triggers(entityCodes: string[]) {
    const { data, error } = await supabase
      .from("trigger_definition_v3")
      .select("*")
      .in("entity_code", entityCodes);
    if (error) throw error;
    const triggers = data || [];
    if (!triggers.length) return { triggers, actions: [] };
    const result = await supabase
      .from("trigger_action_v3")
      .select("*")
      .in(
        "trigger_id",
        triggers.map((t) => t.id),
      )
      .order("action_order");
    if (result.error) throw result.error;
    return { triggers, actions: result.data || [] };
  },
  async saveTrigger(
    trigger: any,
    conditions: any,
    actions: any[],
    expectedUpdatedAt: string | null,
  ) {
    const { data, error } = await supabase.rpc("save_raid_trigger_v3", {
      p_trigger: trigger,
      p_groups: conditions.groups,
      p_conditions: conditions.conditions,
      p_actions: actions,
      p_expected_updated_at: expectedUpdatedAt,
    });
    if (error) throw error;
    window.dispatchEvent(new Event("triggersUpdated"));
    return data;
  },
};
